import React from "react";
import fields from "../../json/Positions.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormTextarea from "Common/Custom/FormTextarea";
import PropTypes from "prop-types";

const AddPositionsForm = ({
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
}) => {
    const { formdata } = fields;
    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Add Position</HeadingOne>
        }>
            {formdata.map((field) => {
                if (field.type === "textarea") {
                    return (
                        <FormTextarea
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }
                // default text input
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Add Position"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

AddPositionsForm.propTypes = {
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default AddPositionsForm;
